export default __webpack_public_path__ + "static/assets1-62eb65a924f49dbb2822c700b4252fd1.svg";